import { createFileRoute } from '@tanstack/react-router';
import PasswordSetupTemplate from '@/features/agent/account/templates/PasswordSetupTemplate';

export const Route = createFileRoute('/account/setup/$id')({
  component: PasswordSetupTemplate,
});
